/* Lake Effect Lures - add-to-cart behaviour that keeps shoppers on the page.
   - Quick add (product cards): le-commerce.js adds over fetch and fires
     `le:cart:updated` with { item }. We show a toast with the free shipping bar.
   - Product page: "Add to cart" adds over fetch and stays put; "Add & check out"
     adds and goes straight to checkout.
   - Cart page: refreshes the free shipping bar when quantities change and loads
     "Other anglers also bought" suggestions.
   Wholesale (Orbit legacy) sessions keep the original form posts so wholesale
   pricing is applied on the cart page. */
(function () {
  'use strict';
  if (window.__leQaToast) return;
  window.__leQaToast = true;

  var html = document.documentElement;
  var isLegacy = html.hasAttribute('data-le-orbit-legacy');
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var toast = null;
  var hideTimer = null;

  function getText(url) {
    return fetch(url, { credentials: 'same-origin' })
      .then(function (res) { return res.ok ? res.text() : ''; })
      .catch(function () { return ''; });
  }

  function freeShipHtml() {
    return getText(root + '?section_id=le-free-shipping').then(function (text) {
      if (!text) return null;
      var doc = new DOMParser().parseFromString(text, 'text/html');
      return doc.querySelector('[data-le-freeship]');
    });
  }

  /* ------------------------------------------------------------ toast --- */

  function buildToast() {
    toast = document.createElement('div');
    toast.className = 'le-qa-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');

    var row = document.createElement('div');
    row.className = 'le-qa-toast__row';
    var text = document.createElement('span');
    text.className = 'le-qa-toast__text';
    var link = document.createElement('a');
    link.className = 'le-qa-toast__link';
    link.href = root + 'cart';
    link.textContent = 'View cart';
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'le-qa-toast__close';
    close.setAttribute('aria-label', 'Close');
    close.innerHTML = '&times;';
    close.addEventListener('click', function () {
      toast.classList.remove('is-visible');
    });
    row.appendChild(text);
    row.appendChild(link);
    row.appendChild(close);

    var ship = document.createElement('div');
    ship.className = 'le-qa-toast__ship';

    toast.appendChild(row);
    toast.appendChild(ship);
    toast.addEventListener('mouseenter', function () { window.clearTimeout(hideTimer); });
    toast.addEventListener('mouseleave', scheduleHide);
    document.body.appendChild(toast);
  }

  function scheduleHide() {
    window.clearTimeout(hideTimer);
    hideTimer = window.setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 5500);
  }

  function showToast(item) {
    if (!toast) buildToast();
    var line = item && item.items ? item.items[0] : item;
    var name = line && line.product_title ? line.product_title : '';
    toast.querySelector('.le-qa-toast__text').textContent = name ? 'Added to cart: ' + name : 'Added to cart';
    var ship = toast.querySelector('.le-qa-toast__ship');
    ship.innerHTML = '';
    toast.classList.add('is-visible');
    scheduleHide();
    freeShipHtml().then(function (bar) {
      if (bar && !bar.hidden) ship.appendChild(bar);
    });
  }

  /* ----------------------------------------- product page: two buttons --- */

  function flashAdded(button) {
    if (!button) return;
    button.classList.add('is-added');
    window.setTimeout(function () { button.classList.remove('is-added'); }, 1600);
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.classList || !form.classList.contains('le-buy-buttons__form')) return;
    if (isLegacy || form.hasAttribute('data-le-native-submit')) return;

    var submitter = event.submitter || null;
    var toCheckout = !!(submitter && submitter.hasAttribute('data-le-add-checkout'));
    var idField = form.querySelector('[name="id"]');
    if (!idField || !idField.value) return;

    event.preventDefault();

    var data = new FormData(form);
    data.delete('return_to');

    if (submitter) {
      submitter.setAttribute('aria-busy', 'true');
      submitter.disabled = true;
    }

    function release() {
      if (!submitter) return;
      submitter.removeAttribute('aria-busy');
      submitter.disabled = false;
    }

    function fallback() {
      // Let Shopify handle it the normal way so the shopper sees its own message.
      form.setAttribute('data-le-native-submit', '');
      if (toCheckout) {
        var hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'return_to';
        hidden.value = '/checkout';
        form.appendChild(hidden);
      }
      HTMLFormElement.prototype.submit.call(form);
    }

    fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      body: data
    })
      .then(function (res) {
        return res.json().then(function (json) { return { ok: res.ok, data: json }; });
      })
      .then(function (result) {
        if (!result.ok) {
          release();
          fallback();
          return;
        }
        if (toCheckout) {
          window.location.href = root + 'checkout';
          return;
        }
        release();
        flashAdded(submitter);
        document.dispatchEvent(new CustomEvent('le:cart:updated', { detail: { item: result.data } }));
      })
      .catch(function () {
        release();
        fallback();
      });
  });

  // Keep "Add & check out" disabled whenever the chosen size is sold out.
  function syncCheckoutButton() {
    var button = document.querySelector('[data-le-add-checkout]');
    if (!button) return;
    var section = document.querySelector('[data-le-product-section]');
    var json = section && section.querySelector('[data-le-product-json]');
    var idInput = section && section.querySelector('[data-le-variant-id]');
    if (!json || !idInput) return;
    var product;
    try { product = JSON.parse(json.textContent); } catch (err) { return; }
    var variant = (product.variants || []).filter(function (v) {
      return String(v.id) === String(idInput.value);
    })[0];
    button.disabled = !(variant && variant.available);
  }
  document.addEventListener('change', function (event) {
    if (event.target && event.target.matches && event.target.matches('[data-le-option-select]')) {
      window.setTimeout(syncCheckoutButton, 60);
    }
  });

  /* ------------------------------------------------------- cart page ---- */

  var cartForm = document.querySelector('[data-le-cart-form]');

  function refreshCartBar() {
    var current = document.querySelector('.le-cart [data-le-freeship]');
    if (!current) return;
    freeShipHtml().then(function (bar) {
      if (bar) current.replaceWith(bar);
    });
  }

  document.addEventListener('le:cart:updated', function (event) {
    var detail = event.detail || {};
    if (detail.item) {
      if (cartForm) {
        // A suggestion was added from the cart page: reload so the new line,
        // subtotal and free shipping bar all show it.
        window.location.reload();
        return;
      }
      showToast(detail.item);
      return;
    }
    if (cartForm) refreshCartBar();
  });

  function cardsFrom(text) {
    if (!text) return [];
    var doc = new DOMParser().parseFromString(text, 'text/html');
    return Array.prototype.slice.call(doc.querySelectorAll('.le-upsell__item'));
  }

  function loadUpsell() {
    var wrap = document.querySelector('[data-le-upsell]');
    if (!wrap) return;
    var ids = (wrap.getAttribute('data-product-ids') || '').split(',').filter(Boolean);
    if (!ids.length) return;
    var limit = parseInt(wrap.getAttribute('data-limit'), 10) || 4;
    var inCart = {};
    ids.forEach(function (id) { inCart[id] = true; });

    var cartTypes = fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var types = {};
        (cart.items || []).forEach(function (line) { if (line.product_type) types[line.product_type] = true; });
        return types;
      })
      .catch(function () { return {}; });

    // What customers buy with the items in the cart, plus the store's best sellers.
    var related = Promise.all(ids.slice(0, 3).map(function (id) {
      return getText(root + 'recommendations/products?section_id=le-cart-upsell&product_id=' + encodeURIComponent(id) + '&limit=10&intent=related');
    }));
    var bestSellers = getText(root + 'collections/all?sort_by=best-selling&section_id=le-cart-upsell');

    Promise.all([cartTypes, related, bestSellers]).then(function (results) {
      var types = results[0];
      var relatedLists = results[1].map(cardsFrom);
      var best = cardsFrom(results[2]);

      // Interleave the related lists so suggestions cover the whole cart.
      var relatedAll = [];
      var longest = relatedLists.reduce(function (max, list) { return Math.max(max, list.length); }, 0);
      for (var r = 0; r < longest; r += 1) {
        relatedLists.forEach(function (list) { if (list[r]) relatedAll.push(list[r]); });
      }
      var candidates = relatedAll.concat(best);

      var picked = [];
      var seen = {};
      var pickedTypes = {};

      function take(node, varietyOnly) {
        if (picked.length >= limit) return;
        var pid = node.getAttribute('data-product-id');
        var type = node.getAttribute('data-product-type') || '';
        if (inCart[pid] || seen[pid]) return;
        if (varietyOnly) {
          // First pass: gear that's different from the cart, one per type.
          if (type && (types[type] || pickedTypes[type])) return;
        }
        seen[pid] = true;
        if (type) pickedTypes[type] = true;
        picked.push(node);
      }

      candidates.forEach(function (node) { take(node, true); });
      candidates.forEach(function (node) { take(node, false); });

      if (!picked.length) return;
      var grid = wrap.querySelector('[data-le-upsell-grid]');
      picked.forEach(function (node) { grid.appendChild(document.importNode(node, true)); });
      wrap.hidden = false;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadUpsell);
  } else {
    loadUpsell();
  }
})();
